import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const OpeningHoursGlyph = /*#__PURE__*/createElement("g", {
  id: "opening_hours"
}, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M69.5,63.6H14.5c-0.6,0-1-0.5-1-1V39.4c0-0.5,0.4-1,1-1h54.9c0.5,0,1,0.5,1,1v23.2C70.5,63.2,70,63.6,69.5,63.6z"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("rect", {
  x: "16.9",
  y: "27.8",
  transform: "matrix(0.707 -0.7072 0.7072 0.707 -11.0921 30.7669)",
  width: "29.4",
  height: "2"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("rect", {
  x: "51.9",
  y: "14",
  transform: "matrix(0.7071 -0.7072 0.7072 0.7071 -5.2826 45.9977)",
  width: "2",
  height: "30.8"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "18.5",
  r: "2.5"
}))));
const OpeningHours = createSvg({
  name: 'opening_hours',
  path: OpeningHoursGlyph
});

export default OpeningHours;
export { OpeningHoursGlyph };
